import { useState } from 'react'

import { Section } from '@factorialco/deprecated-design-system'
import {
  ProfileEmployeeMembershipFragment,
  ProfileEmployeeTeamFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import AssingTeamsModal from 'modules/profile/components/Teams/AssignTeamsModal'
import TeamMemberships from 'modules/profile/components/Teams/TeamMemberships'

interface Props {
  employeeId: string
  isEmployeeActive: boolean
  employeeMemberships: ProfileEmployeeMembershipFragment[]
  isCurrentEmployee: boolean
  teams: ProfileEmployeeTeamFragment[]
  canManageTeams: boolean
}

const Teams = ({
  employeeId,
  isEmployeeActive,
  employeeMemberships,
  isCurrentEmployee,
  teams,
  canManageTeams,
}: Props) => {
  const [teamsModal, setTeamsModal] = useState(false)

  const onClickTeamsModal = () => {
    setTeamsModal(true)
  }

  const onCloseTeamsModal = () => {
    setTeamsModal(false)
  }

  return (
    <>
      <Section
        illustration="group"
        title={i18n.t('employee_form.teams')}
        description={i18n.tCurrent('employee_form.teams_info', isCurrentEmployee)}
        action={
          canManageTeams && teams.length > 0 && isEmployeeActive
            ? {
                label: i18n.t('employee_form.teams_info.assign_teams'),
                onClick: onClickTeamsModal,
              }
            : undefined
        }
      >
        <TeamMemberships
          employeeId={employeeId}
          teamMemberships={employeeMemberships}
          canManageTeams={canManageTeams}
          isTerminated={!isEmployeeActive}
        />
      </Section>
      {teamsModal && canManageTeams && teams.length > 0 && (
        <AssingTeamsModal
          employeeMemberships={employeeMemberships}
          employeeId={employeeId}
          authorizedTeams={teams}
          onCloseTeamsModal={onCloseTeamsModal}
        />
      )}
    </>
  )
}

export default Teams
